import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import { ReactComponent as AudiencesIcon } from '../../../../assets/sightx-icons/svg/sx-users.svg';
import { isPermissionDisabled, isPermissionHidden } from '../../../../utils/accessControl/index.helper';
import { selectors } from '../../../../slices/accounts/accountSelectors';
import { selectors as authSelectors } from '../../../../slices/auth/authSelectors';
import Option from '../Option';
import { Features, isFeatureEnabled } from '../../../../featureToggles/features';

interface IProps {
  href: string;
  isLapsedAccount: boolean;
}

export const AudienceOption = memo((props: IProps) => {
  const recipientsCommunityStatus = useSelector(selectors.getRecipientsCommunityStatus);
  const sectionSecurityPermissions = useSelector(authSelectors.getSectionSecurityPermissions);

  if (isPermissionHidden(recipientsCommunityStatus) || isFeatureEnabled(Features.Communities)) {
    return null;
  }
  const isRecipientsCommunityDisabled = isPermissionDisabled(recipientsCommunityStatus);
  const { isLapsedAccount, href } = props;

  return <Option
    key="Audiences"
    href={href}
    disabled={isLapsedAccount || isRecipientsCommunityDisabled}
    locked={isRecipientsCommunityDisabled}
    disabledByAccessPermission={!sectionSecurityPermissions?.distribute}
  >
    <AudiencesIcon />Audiences
  </Option>;
});
